// ==========================================================
// File: src/pages/ChatWindow.jsx (Commercial Look)
// ==========================================================

import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, TextField, Button, Avatar } from '@mui/material'; // Import Avatar
import SendIcon from '@mui/icons-material/Send';


const ChatWindow = ({ user, messages, onSendMessage }) => {
    // WALANG BINAGO SA LOGIC at HOOKS
    const [input, setInput] = useState('');
    const chatEndRef = useRef(null);

    // Auto-scroll logic
    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleSend = () => {
        if (!input.trim()) return;
        onSendMessage(user.userId, input);
        setInput('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
            
            
            <Box sx={{ p: 2, borderBottom: '1px solid #ddd', bgcolor: '#ffffff', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#007bff', color: 'white', mr: 1.5 }}>
                    {user.email.charAt(0).toUpperCase()}
                </Avatar>
                <Box>
                    <Typography variant="subtitle1" fontWeight="bold" color="#333">
                        {user.email.split('@')[0]}
                    </Typography>
                    <Typography variant="caption" color="#00C853" fontWeight="bold">
                        Online
                    </Typography>
                </Box>
            </Box>

            
            <Box sx={{ 
                flexGrow: 1, 
                p: 2, 
                overflowY: 'auto', 
                display: 'flex', 
                flexDirection: 'column', 
                gap: 1.5, // Mas malaking gap
                bgcolor: '#f7f9fc' // Light subtle background
            }}>
                {messages.length === 0 ? (
                    <Box sx={{ textAlign: 'center', mt: 'auto', mb: 'auto' }}>
                        <Typography color="text.secondary" variant="body2">
                            No messages yet. Start a conversation with {user.email}.
                        </Typography>
                    </Box>
                ) : (
                    messages.map((msg, index) => (
                        <Box
                            key={msg.id || index}
                            sx={{
                                maxWidth: '70%', // Bahagyang nililitan
                                p: 1.5, 
                                borderRadius: '15px', // Mas rounded, modern bubble
                                borderBottomRightRadius: msg.sender === 'support' ? 0 : '15px', // Tail effect
                                borderBottomLeftRadius: msg.sender === 'support' ? '15px' : 0,
                                alignSelf: msg.sender === 'support' ? 'flex-end' : 'flex-start',
                                // Admin (Support) color: Vibrant Blue
                                bgcolor: msg.sender === 'support' ? '#007bff' : '#ffffff', 
                                color: msg.sender === 'support' ? 'white' : '#333',
                                boxShadow: 2, // Mas malaking shadow para sa 'lifted' effect
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.01)', // Konting hover effect
                                }
                            }}
                        >
                            <Typography variant="body2" sx={{ wordWrap: 'break-word' }}>
                                {msg.text}
                            </Typography>
                            <Typography 
                                variant="caption" 
                                sx={{ 
                                    display: 'block', 
                                    textAlign: 'right', 
                                    opacity: 0.7, 
                                    mt: 0.5, 
                                    color: msg.sender === 'support' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.6)' 
                                }}
                            >
                                {msg.time || new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </Typography>
                        </Box>
                    ))
                )}
                <div ref={chatEndRef} />
            </Box>

            
            <Box sx={{ p: 1.5, borderTop: '1px solid #e0e0e0', display: 'flex', gap: 1, flexShrink: 0, bgcolor: '#ffffff' }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Type your message..."
                    size="medium" // Bahagyang nilakihan ang size
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyPress}
                    sx={{ 
                        '& fieldset': { borderRadius: 3, borderColor: '#ccc' },
                        '&:hover fieldset': { borderColor: '#007bff !important' },
                        '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                            borderColor: '#007bff !important', // Blue focus ring
                        },
                    }}
                />
                <Button 
                    variant="contained" 
                    onClick={handleSend} 
                    disabled={!input.trim()}
                    endIcon={<SendIcon />}
                    sx={{ 
                        bgcolor: '#007bff', 
                        '&:hover': { bgcolor: '#0056b3' },
                        borderRadius: 3,
                        textTransform: 'none',
                        minWidth: 100, // Fixed width
                        fontWeight: 'bold'
                    }}
                >
                    Send
                </Button>
            </Box>
        </Box>
    );
};

export default ChatWindow;